export const POSITIONS_ENDPOINTS = {
   APPLICATION: (positionId: string | number) => `/positions/${positionId}/application`,
   DETAIL: (positionId: string | number) => `/positions/${positionId}`,
};
